import { Button, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { clickIcon, downloadIcon, logoutDuotone, plus } from "../../constant/icons";
import { DataView } from "../../components/table/table";
import { columns } from "./columns";
import PageLayout from "../layout/page";
import { useApi } from "../../helper/apiHook";
import { useEffect } from "react";
import { useAddUpdate } from "../../helper/addUpdateHook";
import { AddUpdateCompany } from "./addUpdate";
import { useNavigate } from "react-router-dom";
import { useApp } from "../../components/app";
import { InfoMessage, message } from "../../components/toast";
import { NOT_ASSOCIATED, conversation_is_deActivated, not_connected } from "./message";
import React, { useState } from 'react';
import { useLoaderHelper } from "../../helper/loaderHelper";
import { useAuth } from "../../components/auth";
import { SubscriptionView } from "./subscription";
import { SelectReckonBook } from "./reckon/bookSelect";


const CompanyList = () => {
  const app = useApp();
  const api: any = useApi("company", true, {}, {}, app.isLoading);
  const loader = useLoaderHelper();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState: any) => !prevState);
  const AddUpdate = useAddUpdate();
  const navigate = useNavigate();
  const auth = useAuth();

  const searchParams = new URLSearchParams(window.location.search);
  let errorMsg: any = searchParams.get("errorMsg");
  const requireSubscription = searchParams.get("requireSubscription");
  const queryTenantId = searchParams.get("tenantId");
  const queryCompanyId = searchParams.get("companyId");
  if (errorMsg) {
    try {
      errorMsg = decodeURIComponent(errorMsg);
    } catch {
      
    }
  }

  // --- modal state for empty company_settings ---
  const [settingsPromptOpen, setSettingsPromptOpen] = useState(false);
  const [orderIdPromptOpen, setOrderIdPromptOpen] = useState(false);
  const [settingsRow, setSettingsRow] = useState<any>(null);
  const [pendingConnectRetry, setPendingConnectRetry] = useState<(() => void) | null>(null);

  const isPlainEmptyObject = (obj: any) =>
    obj &&
    typeof obj === "object" &&
    obj.constructor === Object &&
    Object.keys(obj).length === 0;

  useEffect(() => {
    if (errorMsg) {
      message("error", errorMsg);
      const timer = setTimeout(() => {
        if (auth.user?.role == "User" && auth?.user?.loginType) {
          navigate(`/${auth?.user?.loginType}/conversation`);
        } else {
          navigate("/conversation");
        }
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [errorMsg, auth.user?.role, auth.user?.loginType, navigate]);

  useEffect(() => {
    api.mutate();
    app.updateConversation(null);
  }, [app.currentApp?.appCode]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (requireSubscription === "true" && app.currentApp?.appCode === "xero") {
      setSettingsRow({
        id: Number(queryCompanyId || 0),
        tenant: [{ id: Number(queryTenantId || 0) }],
      });
      setOrderIdPromptOpen(true);
    }
  }, [requireSubscription, queryCompanyId, queryTenantId, app.currentApp?.appCode]);

  const onRowDoubleClick = (e: any, event: any) => {
    onJobView(event.childProps.rowData?.tenant?.[0]?.id, event.childProps.rowData);
  };

  const onJobView = (id: any, row: any) => {

    if (!row.isActivate) {
      message("info", conversation_is_deActivated);
    } else if (id > 0) {
      if (!row.company_settings || isPlainEmptyObject(row.company_settings) || row?.company_settings?.date === "") {
        setSettingsRow(row);
        setSettingsPromptOpen(true);
        return;
      }
      if (app.currentApp?.appCode === "xero" && row?.tenant?.[0] && !row.tenant[0].isSubscribe) {
        setSettingsRow(row);
        setOrderIdPromptOpen(true);
        return;
      }

      if (row?.tenant?.[0]?.isConnected == false) {
        InfoMessage(not_connected);
      }
      app.updateConversation(row);
      if (auth.user?.role == "User" && auth.user?.loginType) {
        navigate(`/${auth.user?.loginType + "/job"}`, {
          state: { action: 'save', data: row },
        });
      } else {
        if (app.currentApp?.appCode == "rdo" && row?.tenant?.[0]?.tenantName?.length <= 0) {
          SelectReckonBook(row?.tenant?.[0]?.id, loader)
        } else {
          navigate("/job", { state: { action: 'save', data: row } });
        }
      }
    } else {
      message("info", NOT_ASSOCIATED);
    }
  }
  const onConnectBlocked = (companyId: any, retry: () => void) => {
    if (app.currentApp?.appCode !== "xero") {
      return;
    }
    setSettingsRow({ id: companyId });
    setPendingConnectRetry(() => retry);
    setOrderIdPromptOpen(true);
  };
  const actions = {
    openAddEditFrom: AddUpdate.openAddEditFrom,
    conversation: app.updateConversation,
    onJobView: onJobView,
    onConnectBlocked: onConnectBlocked
  }
  return AddUpdate.viewAddUpdate ? (
    <AddUpdateCompany
      closeAddUpdate={AddUpdate.closeAddEditFrom}
      api={api}
      value={AddUpdate.currentValue}
    />
  ) : (
    <>
      <PageLayout
        title="List of Company"
        item={
          <div className="d-flex gap-2">
            <Button
              color="primary"
              onClick={() =>
                AddUpdate.openAddEditFrom({
                  date: null,
                  remark: "",
                  email: "",
                  name: "",
                  contact_person: [],
                  company_settings: {
                    date: undefined,
                    dateFormat: `dd/MM/yyyy`
                  },
                })
              }
            >
              {plus.icon}Add New Company
            </Button>
            <Dropdown className="template_download" isOpen={dropdownOpen} toggle={toggle}>
              <DropdownToggle color="secondary">
                <span>{downloadIcon.icon}</span>
                {app.currentApp?.templateUrl && (
                  <a
                    className="m-0"
                    href={app.currentApp?.templateUrl}
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: "white" }}
                  >
                    Download Templates
                  </a>
                )}
              </DropdownToggle>
              {/* <DropdownMenu>
                      <DropdownItem>
                        All
                      </DropdownItem>
                      <DropdownItem>
                        <span>{downloadIcon.icon}</span>
                        Currencies
                      </DropdownItem>
                      <DropdownItem>
                        <span>{downloadIcon.icon}</span>
                        Tax Master
                      </DropdownItem>
                      <DropdownItem>
                        <span>{downloadIcon.icon}</span>
                        Purchase Orders
                      </DropdownItem>
                      <DropdownItem>
                        <span>{downloadIcon.icon}</span>
                        Allocation
                      </DropdownItem>
                      <DropdownItem>
                      <span>{downloadIcon.icon}</span>
                        Supplier Credit Note
                      </DropdownItem>
                  </DropdownMenu> */}
            </Dropdown>
          </div>
        }
        View={
          <>
            <DataView
              columns={columns(api, actions, loader)}
              rows={api.data}
              currentPage={api.currentPage}
              onRowDoubleClick={onRowDoubleClick}
              rowCount={api.rowCount}
              limit={api.limit}
              updatePagination={api.updatePagination}
            />
            <div className="doubleclick_note">
              <p>
                <span>{clickIcon.icon}</span>View Function double-click on row
              </p>
            </div>
          </>
        }

      />      {/* --- Modal shown when company_settings is empty --- */}

      <Modal isOpen={settingsPromptOpen} toggle={() => setSettingsPromptOpen(false)} centered>
        <ModalHeader toggle={() => setSettingsPromptOpen(false)}>Company Settings Missing</ModalHeader>
        <ModalBody>
          {settingsRow?.name ? (
            <p className="mb-0">
              <b>{settingsRow.name}</b> has an empty <code>company_settings</code>.
              Please fill in the required settings (e.g., <code>conversation Start date</code>) before proceeding.
            </p>
          ) : (
            <p className="mb-0">
              <code>company_settings</code> is empty. Please fill in the required settings before proceeding.
            </p>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={() => {
              // Open your existing Add/Edit form prefilled with the row
              AddUpdate.openAddEditFrom({
                ...settingsRow,
                company_settings: settingsRow?.company_settings ?? {},
              });
              setSettingsPromptOpen(false);
            }}
            Open Settings
          >
          </Button>
          <Button color="secondary" outline onClick={() => setSettingsPromptOpen(false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      {orderIdPromptOpen && (
        <SubscriptionView
          subscription={orderIdPromptOpen}
          PlanToggle={() => setOrderIdPromptOpen(false)}
          companyId={settingsRow?.id}
          tenantId={settingsRow?.tenant?.[0]?.id}
          onSubscribed={() => {
            api.mutate();
            setOrderIdPromptOpen(false);
            pendingConnectRetry?.();
            setPendingConnectRetry(null);
          }}
        />
      )}
    </>
  );
};

export { CompanyList };
